const encoder = new TextEncoder()

export const StringToUInt8 = (value: string): Uint8Array =>
  encoder.encode(value)
